import { render, staticRenderFns } from "./ticket-table.vue?vue&type=template&id=bfff83ae&scoped=true&"
import script from "./ticket-table.vue?vue&type=script&lang=js&"
export * from "./ticket-table.vue?vue&type=script&lang=js&"
import style0 from "./ticket-table.vue?vue&type=style&index=0&id=bfff83ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfff83ae",
  null
  
)

export default component.exports